// extracted by mini-css-extract-plugin
module.exports = {"RedTitle":"RedTitle_RedTitle___69fK","Number":"RedTitle_Number__2iFCv","Title":"RedTitle_Title__3Si-j","Text":"RedTitle_Text__2LkoO"};